// utils/colors.js
export function stringToHue(str) {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }
  return Math.abs(hash % 360);
}

export function getCategoryColor(category) {
  const hue = stringToHue(category);
  // Use HSL for vibrant, readable colors
  return `hsl(${hue}, 70%, 55%)`;
}
